//chemin: src/components/FormatPrice.jsx
export default function FormatPrice(price) {
  if (price === undefined || price === null) return '0 π';
  
  const num = typeof price === 'string' ? parseFloat(price) : price;
  if (isNaN(num)) return '0 π';
  
  // ✅ Arrondir à 7 décimales pour éviter les erreurs flottantes
  const rounded = Math.round(num * 1e7) / 1e7; // ✅ 7 décimales max = standard Pi/Stellar
  const fixedNum = rounded.toFixed(7); // ✅ 7 décimales max = standard Pi/Stellar
  const trimmedNum = fixedNum.replace(/\.?0+$/, ''); // supprime les zéros inutiles
  const parts = trimmedNum.split('.');
  const integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); // ajoute des virgules pour les milliers
  const decimal = parts[1];
  
  return decimal ? `${integer}.${decimal} π` : `${integer} π`;
}